import { Moment } from "moment";
import { useEffect, useState } from "react";
import { optionsPOST, url_interna } from "../../../config/constants";

import { useLocalStorage } from "hooks/otros/useLocalStorage";
import { useVerifyResponse } from "hooks/otros/useVerifyReponse";
import moment from "moment";
import { TableColumnsType } from "antd";

import { useLayout } from "hooks/otros/useLayout";

import { useSearchTableNew } from "hooks/otros/useSearchTableNew";
import { useExport } from "hooks/otros/useExport";

type DevolucionesProveedores = {
  key: React.Key;
  Cod_MIA: string;
  Producto: string;
  Cantidad: number;
  FraccionDv: number;
  Fecha: string;
  Nombres_Rol: string;
};

const breadcrumbs = [
  { Label: "Inventarios", Url: "/inventario" },
  { Label: "Logistica", Url: "/inventarios/logistica" },
  { Label: "Devoluciones a proveedores" },
];
//const breadcrumbs = [{ Label: "Inventarios", Url: "/inventario" }, { Label: "Productividad" }];

const openKeys = [breadcrumbs[0].Label, breadcrumbs[0].Label + "/" + breadcrumbs[1].Label];
export function useDevolucionesProveedor() {
  useLayout(breadcrumbs, openKeys, breadcrumbs[1].Label + "/" + breadcrumbs[2].Label);
  const [datos, setDatos] = useState<DevolucionesProveedores[]>([]);
  const [searchText] = useState("");
  const [filteredData, setFilteredData] = useState<DevolucionesProveedores[]>([]);
  const { getColumnSearchPropsNew } = useSearchTableNew<DevolucionesProveedores>();
  const { exportToExcel } = useExport();
  let { optionsPost } = useLocalStorage();
  const { isError } = useVerifyResponse();
  const [[fechaInicio, fechaFin], setFechas] = useState<[Moment | null, Moment | null]>([null, null]);
  const [dataEstado, setDataEstado] = useState<boolean>(false);

  const [estadoBotones, setDataBoton] = useState<boolean>(false);

  useEffect(() => {
    if (!searchText) {
      setFilteredData(datos); // Si no hay texto de búsqueda, muestra todos los datos
    } else {
      const filtered = datos.filter((item) => item.Producto.toLowerCase().includes(searchText.toLowerCase()));
      setFilteredData(filtered);
    }
  }, [searchText, datos]);

  const columns: TableColumnsType<DevolucionesProveedores> = [
    {
      title: "Cod Mia",
      dataIndex: "Cod_MIA",
      className: "letraPequenaVisor2",
      key: "Cod_MIA",
      width: "100px",
    },
    {
      title: "Producto",
      dataIndex: "Producto",
      className: "letraPequenaVisor2",
      key: "Producto",
      ...getColumnSearchPropsNew("Producto"),
    },
    {
      title: "Cantidad",
      dataIndex: "Cantidad",
      className: "letraPequenaVisor2",
      key: "Cantidad",
      width: "150px",
    },
    {
      title: "Unidad Medida",
      dataIndex: "FraccionDv",
      key: "FraccionDv",
      className: "letraPequenaVisor2",
      width: "150px",
    },

    {
      title: "Fecha",
      dataIndex: "Fecha",
      key: "Fecha",
      className: "letraPequenaVisor2",
    },
    {
      title: "Usuario",
      dataIndex: "Nombres_Rol",
      key: "Nombres_Rol",
      className: "letraPequenaVisor2",
    },
  ];
  const disabledDate = (current: moment.Moment) => {
    const currentYear = moment().year(); // Año actual

    if (!fechaInicio) {
      // Si no hay fechaInicio, deshabilitar fechas futuras y años distintos al actual
      return current && (current.year() !== currentYear || current > moment().endOf("day"));
    }

    const minDate = fechaInicio.clone().startOf("day");
    const maxDate = fechaInicio.clone().add(6, "months").add(1, "days").endOf("day");
    const today = moment().endOf("day");

    // Deshabilitar fechas fuera del rango permitido o años distintos al actual
    return current && (current.year() !== currentYear || current < minDate || current > maxDate || current > today);
  };
  const getCargosTransferencias = async (fechaInicio: Moment, fechaFin: Moment) => {
    setDataEstado(false);
    setDataBoton(true);
    try {
      const res = await fetch(
        url_interna + "api/inventarios/obtener_reporte_devoluciones_proveedor",
        optionsPOST(
          JSON.stringify({ fechaInicio: fechaInicio!.format("DD/MM/YYYY"), fechaFin: fechaFin!.format("DD/MM/YYYY") }),
          {
            "api-token": "apitoken",
          }
        )
      );
      if (isError(res)) throw new Error();
      const respuesta = await res.json();

      if (respuesta.msg !== "err") {
        const respuestas: DevolucionesProveedores[] = respuesta.data;
        setDataEstado(true);
        setDataBoton(false);
        setDatos(
          respuestas.map(({ Cod_MIA, Producto, Cantidad, FraccionDv, Fecha, Nombres_Rol, key }) => ({
            Cod_MIA,
            Producto,
            Cantidad,
            FraccionDv,
            Fecha,
            Nombres_Rol,
            key,
          }))
        );
      } else {
        setDataEstado(false);
        setDataBoton(false);
        return { msg: "Ocurrio un error", status: false };
      }
    } catch (e) {
      setDataEstado(false);
      setDataBoton(false);
      return { msg: "no_conexion", status: false };
    }
  };

  const handleChangeButton = () => {
    try {
      if (fechaInicio && fechaFin) {
        getCargosTransferencias(fechaInicio, fechaFin);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleClickDownloadData = () => {
    const datosParaExportar = datos.map(({ key, ...resto }) => resto);
    exportToExcel(
      datosParaExportar,
      "Reporte Devoluciones a proveedor - " + fechaInicio!.format("DD/MM/YYYY") + " - " + fechaFin!.format("DD/MM/YYYY")
    );
  };

  return {
    columns,
    filteredData,
    handleChangeButton,
    estadoBotones,
    disabledDate,
    dataEstado,
    getCargosTransferencias,
    searchText,
    optionsPost,
    fechaInicio,
    fechaFin,
    setFechas,
    handleClickDownloadData,
  };
}
